<ng-template #vendorStatementGridRef>
    @if (gridName) {
        <page-grid [gridConfig]="vendorStatementGrid" />
    } @else {
        <h3>No Vendor Statement found</h3>
    }
</ng-template>

@if(data) {
    <modal-panel
      [title]="'Vendor Statement'"
      (close)="closeModal()"
      data-testid="vendor-statement-modal-panel">
      
      <ng-container [ngTemplateOutlet]="vendorStatementGridRef"></ng-container>
  
      <ng-container modalPanelFooter data-testid="vendor-statement-modal-panel-footer">
        <button mat-button mat-raised-button color="primary" (click)="closeModal()" data-testid="vendor-statement-modal-panel-close-button">Close</button>
      </ng-container>
      
    </modal-panel>
  } @else {
    <ng-container [ngTemplateOutlet]="vendorStatementGridRef"></ng-container>
  }
  